import React from 'react';

const inbuiltPlaceholder = 'This is required field';

const RequiredFormControl = (allprops) => {
  const { component, disableRequired, ...props } = allprops;
  const requiredProps = { placeholder: allprops.placeholder || inbuiltPlaceholder };
  let outerProps = {};
  let componentProps = { ...props };
  if (!disableRequired && !allprops.disabled) {
    componentProps = { ...componentProps, ...requiredProps };
    outerProps = { ...outerProps, className: 'required' };
  }
  return (
    <span className={outerProps.className}>
      {React.createElement(component, componentProps)}
    </span>
  );
};

RequiredFormControl.propTypes = {
  component: React.PropTypes.func.isRequired,
  disableRequired: React.PropTypes.bool,
  placeholder: React.PropTypes.string,
};

RequiredFormControl.defaultProps = {
  disableRequired: false,
};

export default RequiredFormControl;
